import { render } from "./Form.vue?vue&type=template&id=1ddf9cc5&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=1ddf9cc5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ddf9cc5"

export default script